import { api } from './BaseApi'
import { ITrainingAiProcessBase } from './dto/TrainingAiProcessDto'

export const trainingAiProcessApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTrainingAiProcessApiList: builder.query<ITrainingAiProcessBase[], void>({
      query: () => ({
        url: '/ai/get_train_details/',
      }),
      providesTags: ['TrainingAiProcess'],
    }),
    getTrainingAiProcessApiDetail: builder.query<ITrainingAiProcessBase, void>({
      query: () => ({
        url: '/ai/get_trainable_model/',
      }),
      providesTags: ['TrainingAiProcess'],
    }),
  }),
})

export const {
  useGetTrainingAiProcessApiListQuery,
  useGetTrainingAiProcessApiDetailQuery,
} = trainingAiProcessApi
